
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activate/account-success",
      function () {
        return require("private-next-pages/activate/account-success/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activate/account-success"])
      });
    }
  